import { useAsyncTask } from "@/composables/useAsyncTask";
import { sendToGrexel } from "../api";
import type { CompanyRecords, SendToGrexelResponse } from "../types";

export function useSendToGrexel() {
  const { state, result, error, errorMessage, execute, reset } =
    useAsyncTask<SendToGrexelResponse>();

  const send = async (companyRecords: CompanyRecords[]) => {
    await execute(sendToGrexel, companyRecords);
  };

  return {
    state,
    result,
    error,
    errorMessage,
    send,
    reset,
  };
}
